module.exports = __webpack_public_path__ + "static/media/wind-energy.5a65270c.png";